import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "n-anchor" }, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'NitroPayAnchorAd',
  setup(__props) {

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
window.nitroAds.createAd('n-anchor', {
  refreshLimit: 20,
  refreshTime: 30,
  format: 'anchor',
  anchor: 'bottom',
  anchorPersistClose: true,
  report: {
    enabled: false,
  },
  mediaQuery: '(min-width: 320px) and (max-width: 767px)',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _hoisted_1
  ]))
}
}

})